import './VersionForceInteraction.scss';
import React from 'react';

const componentInfo = {
  name: 'VersionForceInteraction',
  className: 'version-force-interaction',
  useType: 'Content',
  componentType: 'Basic',
};
const VersionForceInteraction = ({
  onClose,
  onAccept,
}: {
  onClose: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void,
  onAccept: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void,
}) => {
  return (
    <div
      className={componentInfo.className}>
      <div className={`${componentInfo.className}-main-frame`}>
        <div className={`${componentInfo.className}-main-frame-header`}>
          <h2>Uygulamanız güncel değil</h2>
        </div>
        <div className={`${componentInfo.className}-main-frame-body`}>
          <p>{'Devam etmek için uygulamanın en son versiyonuna güncellemeniz gerekmektedir.'}</p>
          <p>{'Uygulamanın güncel versiyonunu indirmek ve yüklemek için Güncelle\'ye tıklayın.'}</p>
        </div>
        <div className={`${componentInfo.className}-main-frame-button-wrapper`}>
          <a className={`${componentInfo.className}-main-frame-button-wrapper-main-button`} href="#" onClick={onAccept}>Güncelle</a>
          <a href="#" onClick={onClose}>Çık</a>
        </div>
      </div>
    </div>
  );
};

export default VersionForceInteraction;
